import { DOCUMENTS_PATH, GET_DOCUMENTS, CIRCULAR_POLICY_PATH, GET_CIRCULAR_POLICY } from "../Common/EndPoints";
import { extractUserDataFromPermission } from "../Utils/Utils";
import { getParsedLocalStorage } from "../Utils/storage-utils";
import { apiAlarms } from "../features/api/apiAlarms";
import { Customer } from "../types";
import { ResponseDocument, SingleDocument } from "../types/document-management/document-management-types";
import { Dayjs } from "dayjs";

export type MODULE =
  | "DOCUMENTS"
  | "CIRCULARS"
  | "FAILURE_ANALYSIS"
  | "PCCL_STORAGE"
  | "TYPICAL_DRAWING_MANAGEMENT"
  | "LATEST_INSTRUCTION_GUIDELINE"
  | "CIRCULAR_MANAGEMENT_SYS";

// Paginated Documents
export type GetPaginatedDocumentsParams = {
  limit: number;
  offset: number;
  doc_name_contain?: string;
  doc_types?: string;
  remark_contain?: string;
  zone_codes?: string;
  div_codes?: string;
  customer_ids?: string;
  from_ts?: number;
  to_ts?: number;
  issuers?: string | null;
  dateTime?: Dayjs | null;
  module: MODULE;
};
type GetPaginatedDocumentsApiResponse = {
  totalRecords: number;
  offset: number;
  limit: number;
  items: ResponseDocument[];
};
type GetPaginatedDocumentsResponse = {
  totalRecords: number;
  offset: number;
  limit: number;
  items: SingleDocument[];
};

//Upload Documents
export type UploadDocumentPayload = {
  params: { module: MODULE };
  body: {
    customer_ids: string[];
    document_name: string;
    document_type: string;
    remark: string | null;
    user_id: string;
    issued_by: null | string;
    published_dt: number | null;
  };
};
export type UploadCircularPolicyParams = {
  customer_id: string;
  document_name: string;
  document_type: string;
  remark: string | null;
  user_id: string;
  issued_by: string | null;
  dateTime: Dayjs | null;
};

export type UploadDocumentAttachment = {
  id: string;
  files: FormData;
  user_id: string;
};

// Delete Attachment
export type DeleteDocumentAttachmentParams = {
  id: string;
  attachment_path: string;
  user_id: string;
};

//EDIT Document
export type EditDocumentPayload = {
  id: string;
  user_id: string;
  body: {
    customer_ids: string[];
    // customer_id: string;
    document_name: string;
    document_type: string;
    remark: string | null;
    user_id: string;
    // user_id: string;
    published_dt: number | null;
    issued_by: string | null;
  };
};
export type EditCircularPolicyParams = {
  id: string;
  user_id: string;
  body: {
    // customer_id: string;
    document_name: string;
    document_type: string;
    remark: string | null;
    issued_by: string | null;
    dateTime: Dayjs | null;
    // user_id: string;
  };
};

export const document_management_apis = apiAlarms.injectEndpoints({
  endpoints: (builder) => ({
    getPaginatedDocuments: builder.query<GetPaginatedDocumentsResponse, GetPaginatedDocumentsParams>({
      query: (params) => {
        return {
          url: GET_DOCUMENTS,
          params,
        };
      },
      providesTags: ["paginated_documents"],
      transformResponse: (response: GetPaginatedDocumentsApiResponse) => {
        const items: SingleDocument[] = response.items.map((document) => {
          const customers: any[] =
            document.customers?.map((customer) => ({
              customerId: customer.id,
              label: customer.station,
              id: customer.id,
              customerName: customer.station,
              section: customer.division,
              division: customer.zone,
            })) ?? undefined;

          const customer_name_list: string = customers.map((customer) => customer.customerName).join(", ");

          return { ...document, customers, customer_name_list };
        });

        return { ...response, items };
      },
    }),
    uploadDocument: builder.mutation<SingleDocument, UploadDocumentPayload>({
      query: ({ params, body }) => {
        const bodyString = JSON.stringify(body);
        return {
          url: DOCUMENTS_PATH,
          method: "POST",
          body: bodyString,
          params,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["paginated_documents"],
    }),
    editDocument: builder.mutation<any, EditDocumentPayload>({
      query: ({ id, body, user_id }) => {
        const bodyString = JSON.stringify(body);
        return {
          url: DOCUMENTS_PATH + `/${id}`,
          method: "PATCH",
          body: bodyString,
          params: { user_id },
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["paginated_documents"],
    }),
    uploadDocumentAttachment: builder.mutation<SingleDocument, UploadDocumentAttachment>({
      query: ({ id, files, user_id }) => {
        return {
          url: DOCUMENTS_PATH + `/${id}/upload`,
          method: "PATCH",
          params: { user_id },
          body: files,
          formData: true,
        };
      },
      invalidatesTags: ["paginated_documents"],
    }),
    deleteDocumentAttachment: builder.mutation<any, DeleteDocumentAttachmentParams>({
      query: ({ id, attachment_path, user_id }) => {
        return {
          url: DOCUMENTS_PATH + `/${id}/remove`,
          method: "DELETE",
          params: { attachment_path, user_id },
        };
      },
      invalidatesTags: ["paginated_documents"],
    }),
  }),
});

// export const circular_policy_management_apis = apiAlarms.injectEndpoints({
//   endpoints: (builder) => ({
//     getPaginatedCircularPolicy: builder.query<GetPaginatedDocumentsResponse, GetPaginatedDocumentsParams>({
//       query: (params) => {
//         return {
//           url: GET_CIRCULAR_POLICY,
//           params,
//         };
//       },
//       providesTags: ["paginated_documents"],
//       // transformResponse: (response: GetPaginatedDocumentsApiResponse) => {
//       //   const permissions = getParsedLocalStorage("permissions");
//       //   const _permissions = extractUserDataFromPermission(permissions);
//       //   const { customerNameToId }: { customerNameToId: any } = _permissions;
//       //   const items: SingleDocument[] = response.items.map((document) => {
//       //     const customer_id: string = customerNameToId[document.station][0];
//       //     const station: Customer = {
//       //       customerId: customer_id,
//       //       customerName: document.station,
//       //       id: customer_id,
//       //       label: document.station,
//       //     };
//       //     return { ...document, station };
//       //   });

//       //   return { ...response, items };
//       // },
//     }),
//     uploadCircularPolicy: builder.mutation<SingleDocument, UploadDocumentPayload>({
//       query: (body) => {
//         const bodyString = JSON.stringify(body);
//         return {
//           url: CIRCULAR_POLICY_PATH,
//           method: "POST",
//           body: bodyString,
//           headers: {
//             "Content-type": "application/json; charset=UTF-8",
//           },
//         };
//       },
//       invalidatesTags: ["paginated_documents"],
//     }),
//     editCircularPolicy: builder.mutation<any, EditCircularPolicyParams>({
//       query: ({ id, body, user_id }) => {
//         const bodyString = JSON.stringify(body);
//         return {
//           url: CIRCULAR_POLICY_PATH + `/${id}`,
//           method: "PATCH",
//           body: bodyString,
//           params: { user_id },
//           headers: {
//             "Content-type": "application/json; charset=UTF-8",
//           },
//         };
//       },
//       invalidatesTags: ["paginated_documents"],
//     }),
//     uploadCircularPolicyAttachment: builder.mutation<SingleDocument, UploadDocumentAttachment>({
//       query: ({ id, files, user_id }) => {
//         return {
//           url: CIRCULAR_POLICY_PATH + `/${id}/upload`,
//           method: "PATCH",
//           params: { user_id },
//           body: files,
//           formData: true,
//         };
//       },
//       invalidatesTags: ["paginated_documents"],
//     }),
//     deleteCircularPolicyAttachment: builder.mutation<any, DeleteDocumentAttachmentParams>({
//       query: ({ id, attachment_path, user_id }) => {
//         return {
//           url: CIRCULAR_POLICY_PATH + `/${id}/remove`,
//           method: "DELETE",
//           params: { attachment_path, user_id },
//         };
//       },
//       invalidatesTags: ["paginated_documents"],
//     }),
//   }),
// });

export default document_management_apis;
